import Cookies from "js-cookie"
import React, { useEffect } from "react"

import { Button } from "@novaescola/eva-react-v2/lib/Button"
import { Typography } from "@novaescola/eva-react-v2/lib/Typography"

import Image from "../general/Image"
import ButtonsActionSection from "./ButtonsActionSection"
import { sanitizeHtml } from "../../utils/sanitize"

export function ActionSection({ section, pageTitle, user }) {
	const isBrowser = () => typeof window !== "undefined";
	const { order } = section;
	const { btnPrimaryText, btnPrimaryBackground } = section.body || {};

	const location = window.location.pathname;
	const validUrl = location === "/tudo-sobre/planos-de-aula-por-whatsapp/";
	
	function isSectionButtonEnabled(section, isSecondButton) {
		if (
			!section.body?.buttonEnabledAt ||
			(isSecondButton && !section.body?.secondButtonEnabledAt)
		) {
			return true
		}

		return isSecondButton
			? new Date(section.body?.secondButtonEnabledAt).getTime() <
			new Date().getTime()
			: new Date(section.body?.buttonEnabledAt).getTime() < new Date().getTime()
	}

	// Condicionais LP Mapfre (https://novaescola.org.br/tudo-sobre/educacao-no-transito/)
	function isLpMapfre() {
		if (section.body?.title.trim() === "Da vida real para as telas") {
			return true
		}
	}
	function isLpMapfreHiddenButton() {
		if (section.body?.title.trim() === "Fundação Mapfre") {
			return true
		}
	}
	//FIM

	function renderLpSondagemInfos() {
		if (section.body?.title.trim() === "Sua principal Ferramenta de apoio em 2025") {
			return <div>
				<p>Facilite sua rotina e potencialize sua prática nessa volta às aulas, tudo gratuito para apoiar os professores.</p>
				<br></br>
				<ul style={{
					listStyleType: 'disc',
					paddingLeft: '30px'
				}} >
					<li>Registre sondagens e organize as informações da turma</li>
					<li>Acompanhe a evolução dos alunos com gráficos e relatório automatizados</li>
					<li>Acesse Planos de Aula e Atividades personalizadas para cada etapa da alfabetização</li>
					<li>Veja dicas e conteúdos rápidos para apoiar sua prática</li>
					<li>Conquiste um certificado de 30 horas ao utilizar os recursos da ferramenta</li>
				</ul>

			</div>
		}

		if (section.body?.title.trim() === "Faça como milhares de Professores e potencialize a Alfabetização durante o ano") {
			return <>
				<div>
					<p> São mais de 60 mil professores utilizando a solução e milhares de estudantes impactados por acompanhamentos mais assertivos e planejamentos personalizados.</p>
					<br></br>
					<p >
						Veja o que os Educadores estão dizendo:
					</p>
					<ul style={{
						listStyleType: 'disc',
						paddingLeft: '30px'
					}} >
						<li>
							“<i><strong>A ferramenta é muito simples, prática e objetiva</strong>, nos oferece em tempo real todo o diagnóstico da turma. Estou adorando e já repliquei para alguns colegas...”</i> - Profª Alessandra.
						</li>
						<br></br>
						<li>
							<i>“Com a ferramenta de sondagem, <strong>pude analisar minuciosamente a situação da minha turma</strong> e desse modo, idealizar e posteriormente, <strong>planejar atividades que os auxilie com mais êxito.”</strong> </i> -	Profª Emanueli.
						</li>
					</ul>
				</div>
				<br></br>
			</>
		}

		if (section.body?.title.trim() === "Conquiste seu certificado de 30 horas") {
			return <>
				<div>
					<p> O acompanhamento da evolução da turma gera um certificado de 30 horas em boas práticas em sondagem escrita. A cada passo feito na ferramenta você avança rumo a certificação, completando as 5 etapas poderá emitir seu certificado e acessar benefícios exclusivos.</p>
					<br></br>
					<p >
						Veja os passos para receber sua certificação:
					</p>
					<br></br>
					<ul style={{
						listStyleType: 'disc',
						paddingLeft: '30px'
					}} >
						<li>
							Cadastre sua turna
						</li>
						<li>
							Realize a primeira sondagem da sua turma
						</li>
						<li>
							Realize a segunda sondagem da sua turma
						</li>
						<li>
							Acesse as Dicas para Sondagem
						</li>
						<li>
							Acesse os Planos de aulas ou Atividades
						</li>
					</ul>
				</div>
				<br></br>
			</>
		}

	}

	function isLpSondagem() {
		const currentUrl = window.location.href
		return currentUrl.includes("sondagem-alfabetizacao");
	}

	useEffect(() => {
		if (isBrowser()) {
			Cookies.set("ane_redirect", window.location.href, {
				domain: ".novaescola.org.br",
			})
		}
	})

	return (
		<>
			<section
				className="container-fluid"
				style={{ backgroundColor: section.body?.backgroundColor }}
			>
				<div className="container blocks">
					<div
						className={`row container-blocks eva-pt-8 eva-pb-8 ${section.body?.imageAlign === "left"
							? "image-aling-left"
							: "image-aling-rigth"
							}`}
					>
						<div className="col-lg-6 col-md-6 col-sm-12 image-block d-flex fd-column jc-center">
							{
								// trecho inserido para validar LP de sondagem, será necessário refatorar quando fizer as alterações no gerador de LP para remover as informações estáticas da página - KA-175
								isLpSondagem() 
									? <Image
											remoteImage={section.body?.imageUrl}
											fallbackImageUrl={section.body?.imageUrl}
											alt={section.body?.altText || " "}
										/>
									: <Image
											remoteImage={section.body?.remoteImage}
											fallbackImageUrl={section.body?.imageUrl}
											alt={section.body?.altText || " "}
										/>
							}
						</div>
						<div
							className={`col-lg-6 col-md-6 col-sm-12 text-block d-flex fd-column jc-center ${isLpMapfreHiddenButton() ? "text-block-mapfre" :""}`}
						>
							{(validUrl && order > 2 && order < 9) &&
								<div className="section-order">
									<p>{order - 3}</p>
								</div>
							} 
							<Typography
								variant="title"
								size={4}
								asChild
								className="eva-margin-bottom-2"
								style={{ color: section.body?.textColor }}
							>
								<h2>{section.body?.title}</h2>
							</Typography>
							<Typography
								variant="body"
								size={1}
								asChild
								className="eva-margin-bottom-4"
								style={{ color: section.body?.textColor }}
							>
								{
									renderLpSondagemInfos() ?? 
										<div
											dangerouslySetInnerHTML={{
												__html: section.body?.subtitle ? 
													sanitizeHtml(section.body?.subtitle) 
													: '',
											}}
										/>
								}

							</Typography>

							<div className="d-flex align-buttom">
								{!section.body?.hideLinkButton && (
									<>
										{isSectionButtonEnabled(section) ? (
											<ButtonsActionSection
												buttonEnabledText={
													section.body?.buttonEnabledText
												}
												buttonLink={section.body?.buttonLink}
												addRegistrationBlockingButton={
													section.body?.addRegistrationBlockingButton
												}
												pageTitle={pageTitle}
												user={user}
												section={section}
											/>
										) : (
											<Button
												disabled
												variant="primary"
												size="large"
												aria-disabled="true"
												style={{
													...(btnPrimaryText && { color: btnPrimaryText }),
													...(btnPrimaryBackground && { 
														backgroundColor: btnPrimaryBackground, 
														border: 'none' 
													})
												}}
											>
												{section.body?.buttonDisabledText}
											</Button>
										)}

										{isLpMapfre() && (
											<Button
												variant="primary"
												size="large"
												asChild
												id="jogarComoAluno"
											>
												<a
													href={
														"https://box.novaescola.org.br/educacao-no-transito?itm_source=aluno&itm_medium=tipo_usuario&itm_campaign=jogo_mapfre"
													}
													target="_self"
													rel="noreferrer"
													type="button"
												>
													Jogar como Aluno
												</a>
											</Button>
										)}
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
